import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    topBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        background: '#fff',
        borderRadius: 8,
        height: 170,
        marginBottom: 20,
        paddingTop: 35,
        '& .Mui-disabled': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #e5e5e5',
                color: '#e5e5e5',
                background: '#fff',
            }
        },
        '& .MuiStepIcon-root': {
            width: 40,
            height: 40,
        },
        '& .MuiStepConnector-alternativeLabel': {
            top: 20,
            left: 'calc(-50% + 30px)',
            right: 'calc(50% + 30px)',
        },
        '& .MuiStepLabel-iconContainer': {
            border: '1px solid #5579f0',
            width: 40,
            height: 40,
            borderRadius: '100%',
            color: '#fff',
            background: '#5579f0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'inline-block',
            lineHeight: '38px',
        },
        '& .MuiStep-completed': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #5579f0',
                color: '#5579f0',
                background: '#fff',
            }
        },
        '& .MuiStepConnector-active': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #fff',
            }
        },
        '& .MuiStepLabel-label': {
            fontSize: '1.125rem',
            letterSpacing: '-0.5px',
            color: '#87888d',
            marginTop: 9,
            wordBreak: 'break-word',
        },
        '& .MuiStepLabel-label.MuiStepLabel-completed': {
            color: '#10121c',
        },
        '& .MuiStepLabel-label.MuiStepLabel-active': {
            color: '#5579f0'
        },
    },
    activeStepIcon: {
        width: '75%',
        padding: 0,
        marginTop: 5,
        '& .MuiStepIcon-active': {
            color: '#5579f0', // 활성 스텝 아이콘 색상 변경
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        // height: 'calc(100vh - 350px)'
    },
    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
            }
        }
    },
    buttonGroup: {
        marginTop: 10,
    },
    imgButtonGroup: {
        '&.MuiBox-root': {
            padding: '10px 0px'
        },
        '& .MuiIconButton-root': {
            padding: 0,
            marginLeft: 28,
            '&:hover': {
                background: 'transparent',
            }
        }
    },
    iconBtnSet: {
        '& .MuiIconButton-root': {
            padding: 0,
            marginLeft: 10,
            '&:hover': {
                background: 'transparent',
            }
        }
    },
    textBorderBox: {
        border: '1px solid #87888d',
        position: 'relative',
        borderRadius: 8,
        width: 'calc(100vw - 1300px)',
        marginLeft: 10,
        height: 36,
        '&.MuiBox-root': {
            padding: '5px 0px',
        },
        '& .MuiTypography-root': {
            padding: '0px 30px 0px 10px'
        }
    },
    iconPosition: {
        position: 'absolute',
        right: 10,
        top: 5,
        '&.MuiBox-root': {
            padding: 0,
        },
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
            width: 110,
            marginRight: 12,
        },
        '& .MuiSelect-select':{
            width: 110,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '0.875rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px #87888d',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            fontSize: '1.125rem',
            color:'#323232',
            boxSizing: 'border-box',
            '&:hover':{
                background: '#eee !important'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
        }
    },
    disableButtonStyle: {
        marginLeft: 10,
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.7)',
            }
        }
    },
    activeButtonStyle: {
        marginLeft: 10,
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        }
    },
    heightStep1: {
        height: 'calc(100vh - 350px)',
        overflowX: 'auto'
    },
    imgContainer: {
        height: '381px',
        width: '631px',
        // border: '1px solid rgb(188, 188, 188)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: '10px 0px'
    },
    textListBox: {
        position: 'relative',
        '&.MuiBox-root': {
            width: 'calc(100vw - 1300px)',
            border: '1px solid #87888d',
            height: 36,
            borderRadius: 8,
            padding: '1px 12px',
            marginLeft: 10,
            marginRight: 5,
            backGroundColor: '#ccc'
        },
    },
    textField: {
        flex: 1,
        border: "none",
        outline: "none",
        fontSize: "0.875rem",
        letterSpacing: "-0.5px",
    },
    volumeIconButton: {
        padding: 0,
        position: 'absolute',
        right: 10,
        top: 5,
        '&:hover':{
            background: 'transparent'
        }
    },




}));

